import React from "react";
import {Box, Tabs, Text} from "@mantine/core";
import {useNavigate, useParams} from "react-router";
import {IconList, IconUser} from "@tabler/icons-react";
import classes from "./PlanningPage.module.css";
import {ProtocolDefinitionDashboardPage} from "./ProtocolDefinitionDashboardPage";
import cx from "clsx";
import {SubjectsPanel} from "./subjects/SubjectsPanel.tsx";

type PlanningSection = "subjects" | "protocols";

interface SidebarItem {
    id: PlanningSection;
    label: string;
    icon: React.ReactNode;
    component: React.ComponentType;
}

const sidebarItems: SidebarItem[] = [
        {
        id: "subjects",
        label: "Subjects",
        icon: <IconUser size={"1em"}/>,
        component: SubjectsPanel,
    },
    {
        id: "protocols",
        label: "Protocols",
        icon: <IconList size={"1em"}/>,
        component: ProtocolDefinitionDashboardPage,
    },
];

export const PlanningPage: React.FC = () => {
    const navigate = useNavigate();
    const section = useParams().section as PlanningSection ?? "protocols";

    return (
        <Box className={classes.root}>
            <Tabs classNames={{list: classes.tabList, tabLabel: classes.tabLabel}} defaultValue={section}
                  orientation={"vertical"} onChange={(value) => navigate(`/planning/${value}`)}>
                <Box className={cx(classes.sidePanel)}>
                    <Tabs.List>
                        {sidebarItems.map((item) => (
                            <Tabs.Tab className={classes.tab} key={item.id} value={item.id}>
                                <Box>
                                    <Box className={classes.tabIcon}>{item.icon}</Box>
                                    <Text ta={"center"} size="sm">{item.label}</Text>
                                </Box>
                            </Tabs.Tab>
                        ))}
                    </Tabs.List>
                </Box>
                {sidebarItems.map((item) => {
                    const PanelComponent = item.component;
                    return (
                        <Tabs.Panel value={item.id} key={item.id}>
                            <Box className={classes.content}>
                                <Box className={classes.contentBody}>
                                    <PanelComponent/>
                                </Box>
                            </Box>
                        </Tabs.Panel>
                    );
                })}
            </Tabs>
        </Box>
    );
};